<template><div><h1>Uncaught SyntaxError: Unexpected token export</h1>
<p>原因是Vux的js源码没配置babel，你可以在webpack配置的loaders加上</p>
<pre class="hljs"><code>{
  <span class="hljs-attr">test</span>: <span class="hljs-regexp">/vux.src.*?js$/</span>,
  <span class="hljs-attr">loader</span>: <span class="hljs-string">'babel'</span>
}
</code></pre>
<p>或者启用<code>vux-loader</code>的<code>vux-ui</code>插件。</p>
</div></template><script>
export default {
  head: {"title":"Uncaught SyntaxError | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// Uncaught-SyntaxError-Unexpected-token-export-16.vue?a5cccbb2